import React, {useEffect} from 'react';
import {FormControlLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import ComplimentaryActivity from "./ComplimentaryActivity";
import ExtraActivity from "./ExtraActivity";
import {useDispatch, useSelector} from "react-redux";
import {setActivitiesOption} from "../../../redux/actions/activitiesActions";

const Activities = () => {
    const {complimentary, extra} = useSelector(state => state.activities);
    // const activitiesOption = useSelector(state => state.activitiesOption);

    // const dispatch = useDispatch();

    return (
        <div>
            <Typography variant="h3" component="h3">
                Special savings on pre-trip adventures!<br/>
                <br/>
            </Typography>
            {!(complimentary.length > 0 || extra.length > 0) &&
                <Typography align={'center'} variant='h4'>No extensions available for this trip,<br/>please contact our
                    office for more information.</Typography>
            }
            <Grid container spacing={3} marginTop={3}>
                <Grid item xs={12} sm={12} md={12} container>
                    {complimentary.length > 0 && <>
                        {complimentary.map((activity) => <Grid key={activity.id} item xs={6}>
                            <ComplimentaryActivity activity={activity}/>
                        </Grid>)}
                    </>}
                    <Grid item xs={12}>
                        {extra.map((activity) => <ExtraActivity key={activity.id} activity={activity}/>)}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default Activities;